import React from 'react';
import { createDevTools } from '@redux-devtools/core';
import { DockMonitor } from '@redux-devtools/dock-monitor';
import { InspectorMonitor } from '@redux-devtools/inspector-monitor';

import { isReduxDevToolsEnabled } from '../utilities/cookies';

const ReduxDevTools = createDevTools(
  <DockMonitor
    defaultPosition="bottom"
    defaultIsVisible={isReduxDevToolsEnabled()}
    toggleVisibilityKey="ctrl-h"
    changePositionKey="ctrl-q"
  >
    <InspectorMonitor invertTheme={false} />
  </DockMonitor>,
);

export default ReduxDevTools;
